import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=5adc635e&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=5adc635e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc635e",
  null
  
)

export default component.exports